module.exports = __webpack_public_path__ + "d9effc2f5900332e03e5cce7cbe037b5.pdf";